export const PENDING_STATUS = 'pending'
export const SUCCESS_STATUS = 'success'
export const FAILURE_STATUS = 'failure'


// WEBPACK FOOTER //
// ./src/modules/redux-acron/constants.js